import { useState, useEffect } from "react";

import { useContextValue } from "../../context/context";
import FilledCard from "../FilledCard/FilledCard";
import { popUps } from "../PopUps";

export const FilledCards = () => {
	const { filledCards } = useContextValue();
	const [activePopUp, setActivePopUp] = useState(null);

	const closePopUp = () => {
		setActivePopUp(null);
	};

	// Prevent body scrolling when modal is open
	useEffect(() => {
		if (activePopUp) {
			document.body.classList.add('modal-open');
		} else {
			document.body.classList.remove('modal-open');
		}

		// Cleanup on unmount
		return () => {
			document.body.classList.remove('modal-open');
		};
	}, [activePopUp]);

	const renderFilledCards = filledCards.map((card, id) => {
		return (
			<FilledCard
				key={id}
				card={card}
				onClick={() => setActivePopUp(card.title)}
			/>
		)
	})

	

	const activePopUpData = popUps.find((popUp) => popUp.key === activePopUp);
	const ActivePopUpComponent = activePopUpData?.component;

	return (
		<div style={filledCards.length === 0 ? { display: "none" } : { marginBottom: "20px" }}>
			{renderFilledCards}
			{ActivePopUpComponent && (
				<div className="pop-up-overlay" onClick={closePopUp}>
					<div className="pop-up-content" onClick={(e) => e.stopPropagation()}>
						<ActivePopUpComponent onClose={closePopUp} />
					</div>
				</div>
			)}
		</div>
	)
}
